import { render, staticRenderFns } from "./lessonBuilder.vue?vue&type=template&id=5e31abc8&scoped=true&"
import script from "./lessonBuilder.vue?vue&type=script&lang=ts&"
export * from "./lessonBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./lessonBuilder.vue?vue&type=style&index=0&id=5e31abc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e31abc8",
  null
  
)

export default component.exports